import * as React from 'react'

import { observer } from 'mobx-react'
import { classList } from 'react-classlist-helper'

import ProjectDateStore from '~/client/src/shared/stores/ui/ProjectDate.store'

import LogisticsGanttStore from '../LogisticsGantt.store'

interface IProps {
  logisticsGanttViewStore: LogisticsGanttStore
  projectDateStore: ProjectDateStore
}

const FILLED_CIRCLE_SYMBOL = '\u25CF'

@observer
export default class LogisticsTimelineHeader extends React.Component<IProps> {
  public render() {
    const { isOneDayView } = this.props.logisticsGanttViewStore

    if (isOneDayView) {
      const {
        timelineColumnHours,
        formatHourLabel,
        currentDate,
        currentTimePosition,
        isNonWorkingHour,
      } = this.props.logisticsGanttViewStore
      const { getWeekdayToDisplay, getMonthAndDayToDisplay } =
        this.props.projectDateStore

      return (
        <div className="col full-height">
          <span className="text size10 center bb-light-cool-grey">
            {`${getWeekdayToDisplay(currentDate)}, ${getMonthAndDayToDisplay(
              currentDate,
            )}`}
          </span>

          <div className="relative full-width full-height row">
            {timelineColumnHours.map((hour, idx) => (
              <div
                key={hour}
                className={classList({
                  'full-height flex-item text text-wrap size10 center': true,
                  'br-light-cool-grey': timelineColumnHours.length !== idx + 1,
                  'bg-palette-brand-lightest': isNonWorkingHour(hour),
                })}
              >
                {formatHourLabel(hour)}
              </div>
            ))}
            {currentTimePosition && (
              <div
                className="absolute gantt-header-current-time text small gold z-index-10"
                style={{
                  left: `${currentTimePosition.pixels}px`,
                }}
              >
                {FILLED_CIRCLE_SYMBOL}
              </div>
            )}
          </div>
        </div>
      )
    }

    const { timelineColumnDays } = this.props.logisticsGanttViewStore
    return (
      <div className="full-width full-height row">
        {timelineColumnDays.map(
          ({ ms, isWeekend, dayName, monthAndDay, isToday }, i) => (
            <div
              key={ms}
              className={classList({
                'col x-center y-center relative full-height text text-wrap small center': true,
                'br-light-cool-grey': timelineColumnDays.length !== i + 1,
                'bg-palette-brand-lightest': isWeekend,
                'bg-white': !isWeekend,
              })}
            >
              {dayName}
              <br />
              {monthAndDay}
              <br />
              {isToday && (
                <div className="row y-end x-center absolute full-width full-height">
                  <div className="absolute text small gold bottom-minus-3">
                    {FILLED_CIRCLE_SYMBOL}
                  </div>
                </div>
              )}
            </div>
          ),
        )}
      </div>
    )
  }
}
